import { useMemo, useReducer } from 'react';
import type { FunctionComponent, ReactNode } from 'react';

import ProductsContext from './ProductsContext';
import { getActions } from './actions';
import { initialState, reducer } from './reducer';
import * as selectors from './selectors';

const ProductsProvider: FunctionComponent<{ children: ReactNode }> = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const actions = useMemo(() => getActions(dispatch), [dispatch]);

  return (
    <ProductsContext.Provider value={{ actions, selectors, state }}>
      {children}
    </ProductsContext.Provider>
  );
};

export default ProductsProvider;
